var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSaveCollection = function SvgSaveCollection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 8C14 4.68667 16.6867 2 20 2C23.3133 2 26 4.68667 26 8C26 11.3133 23.3133 14 20 14C16.6867 14 14 11.3133 14 8Z",
    fill: "url(#paint0_linear_235_2024)",
    stroke: "url(#paint1_linear_235_2024)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 4.5C20.928 4.5 21.819 4.86901 22.4753 5.52539C23.1315 6.18173 23.4998 7.07191 23.4998 8V20.4473L23.9451 20.4971L38.3865 22.1025C39.2422 22.1977 40.0328 22.6056 40.6072 23.2471C41.1815 23.8886 41.4994 24.7191 41.4998 25.5801V40C41.4998 40.9281 41.1315 41.8183 40.4753 42.4746C39.819 43.131 38.928 43.5 37.9998 43.5H16.7244C16.3728 43.5 16.0313 43.3763 15.7634 43.1533L5.36987 34.4902C5.13809 34.2972 4.97014 34.0381 4.88745 33.748C4.80488 33.4582 4.81103 33.1502 4.90601 32.8643L4.90698 32.8633L5.13257 32.1836C5.28331 31.7313 5.52496 31.3146 5.84253 30.959C6.16022 30.6032 6.54758 30.316 6.98022 30.1152C7.41272 29.9146 7.88157 29.8039 8.35815 29.791C8.83493 29.7781 9.30982 29.863 9.75269 30.04L15.8142 32.4639L16.4998 32.7383V8C16.4998 7.0718 16.8689 6.18176 17.5251 5.52539C18.1815 4.86907 19.0716 4.50007 19.9998 4.5Z",
    fill: "#8F3E47",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_235_2024",
    x1: 14.6662,
    y1: 2,
    x2: 25.3338,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8F3E47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F2BB05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A65301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_235_2024",
    x1: 14.6662,
    y1: 2,
    x2: 25.3338,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8F3E47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F2BB05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A65301"
  })))));
};
export default SvgSaveCollection;